import api from './api';

const countryHubService = {
  async getCountryHub() {
    const response = await api.get('/partners/country-hub');
    return response.data;
  },

  async updateCountryHub(hubData) {
    const response = await api.put('/partners/country-hub', hubData);
    return response.data;
  },

  async publishCountryHub(publish = true) {
    const response = await api.post('/partners/country-hub/publish', { publish });
    return response.data;
  },

  async listProfiles() {
    const response = await api.get('/partners/country-hub/profiles');
    return response.data;
  },

  async applyProfile(profileKey, force = false) {
    const response = await api.post('/partners/country-hub/apply-profile', { profileKey, force });
    return response.data;
  },

  async uploadImage(file, type) {
    const formData = new FormData();
    formData.append('image', file);
    // El cliente axios global tiene 'Content-Type: application/json' como default.
    // Sin override, axios lo respeta y serializa el FormData como JSON
    // ({"image":"<File>"} -> 12 bytes), multer no encuentra el archivo y devuelve
    // 400 'Imagen requerida'. Pasar Content-Type: undefined fuerza a axios a
    // regenerar el header con el boundary correcto al detectar FormData.
    const response = await api.post(`/partners/country-hub/upload?type=${type}`, formData, {
      headers: { 'Content-Type': undefined }
    });
    return response.data;
  }
};

export default countryHubService;
